import PropTypes from "prop-types";
import { AnimatePresence, motion } from "framer-motion";

function AnimatedNumber({ value = 0, userValue = 0 }) {
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={value}
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 10 }}
        transition={{ duration: 0.3 }}
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          //   borderBottom: "solid",
          padding: 16,
          //   borderWidth: 1,
          //   borderColor: "#94bde5",
        }}
      >
        <div style={{ textAlign: "center", margin: "0 20px" }}>
          <span
            style={{
              fontSize: "4em",
              fontWeight: "bold",
              fontFamily: "SF Pro Text",
            }}
          >
            {value}
          </span>

          <div
            style={{
              fontSize: "1em",
              fontWeight: "bold",
              fontFamily: "SF Pro Text",
            }}
          >
            Hole
          </div>
        </div>
        <div style={{ textAlign: "center", margin: "0 20px" }}>
          <span
            style={{
              fontSize: "4em",
              fontWeight: "bold",
              fontFamily: "SF Pro Text",
            }}
          >
            {userValue || "?"}
          </span>
          <div
            style={{
              fontSize: "1em",
              fontWeight: "bold",
              fontFamily: "SF Pro Text",
            }}
          >
            Score
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}

AnimatedNumber.propTypes = {
  value: PropTypes.number.isRequired,
  userValue: PropTypes.number.isRequired,
};

export { AnimatedNumber };
